import { Icon } from '@/components/Icon';

/**
 * Индикатор шагов мастера — назад можно вернуться на любой уже пройденный
 * шаг напрямую (кликом), вперёд — только через "Далее" (проходит валидацию
 * промежуточных шагов). Клик по шагу дальше maxReached просто ничего не
 * делает — кнопка задизейблена, а не скрыта, чтобы был виден весь путь.
 * Пройденный шаг — сплошной акцентный кружок с белой галочкой; активный —
 * кружок с акцентной обводкой и акцентным номером (не залит); ещё не
 * достигнутый — серая обводка. Один и тот же акцентный (тил) цвет везде, без
 * отдельного зелёного для "готово". Подпись — по центру под кружком.
 *
 * Общий для мастеров создания клиента и администратора: подписи шагов —
 * пропсом, своя нумерация внутри.
 */
export function WizardStepper({
  steps,
  current,
  maxReached,
  onStepClick,
}: {
  steps: readonly string[];
  current: number;
  maxReached: number;
  onStepClick: (step: number) => void;
}) {
  return (
    <ol className="wizard__steps" role="tablist">
      {steps.map((label, i) => {
        const step = i + 1;
        const done = step < current;
        const active = step === current;
        const clickable = step <= maxReached;
        return (
          <li
            key={step}
            className={`wizard__step${active ? ' wizard__step--active' : ''}${done ? ' wizard__step--done' : ''}`}
          >
            {step < steps.length && (
              <span
                className={`wizard__step-connector${done ? ' wizard__step-connector--filled' : ''}`}
                aria-hidden="true"
              />
            )}
            <button
              type="button"
              role="tab"
              aria-selected={active}
              className="wizard__step-btn"
              disabled={!clickable}
              onClick={() => onStepClick(step)}
            >
              <span className="wizard__step-index">{done ? <Icon name="check" size={14} /> : step}</span>
              <span className="wizard__step-label">{label}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
